import { PageTypes } from "@shared/types/commonTypes";
import { ROOTS } from "@app/config/constants";
import { useLocation } from "react-router-dom";

const usePageType = (): PageTypes | null => {
  const location = useLocation();
  const { pathname: path } = location;

  if (path.startsWith(ROOTS.CLINIC)) {
    return PageTypes.CLINIC;
  } else if (path.startsWith(ROOTS.PATIENT)) {
    return PageTypes.PATIENT;
  } else if (path.startsWith(ROOTS.USER)) {
    return PageTypes.USER;
  } else if (path.startsWith(ROOTS.EVENTS)) {
    return PageTypes.EVENT;
  }
  return null;
};

export default usePageType;
